import React, { useState } from 'react'
import {
  OrderFieldConfig,
  Order,
  OrderDirection,
  useOrderManager
} from '../../legacy-design-system/order'
import {
  FilterManager,
  FilterManagerChildProps,
  FilterType
} from '../filter-manager'
import {
  useRowHeightsCache,
  UseRowHeightsCacheProps
} from '../row-height-cache'

interface ChildProps<
  TOrderField extends string,
  TAggregationCategory extends string
> extends FilterManagerChildProps<TAggregationCategory>,
    UseRowHeightsCacheProps {
  readonly order: Order<TOrderField>
  readonly onSetSortField: (field: TOrderField) => void
  readonly onSetSortDirection: (direction: OrderDirection) => void
  readonly hasData: boolean
  readonly onHasData: (hasData: boolean) => void
}

interface Props<
  TOrderField extends string,
  TAggregationCategory extends string
> {
  readonly defaultOrderField: TOrderField
  readonly orderFieldConfig: OrderFieldConfig<TOrderField>
  readonly initialQuickFilterID?: string
  readonly filterType: FilterType
  readonly children: (
    props: ChildProps<TOrderField, TAggregationCategory>
  ) => React.ReactElement
}

export function GridStateManager<
  TOrderField extends string,
  TAggregationCategory extends string
>({
  defaultOrderField,
  orderFieldConfig,
  initialQuickFilterID,
  filterType,
  children
}: Props<TOrderField, TAggregationCategory>) {
  const [hasData, onHasData] = useState(false)

  const {
    maxCellHeightsByRow,
    updateCellHeight,
    registerListRef,
    recomputeRowHeights
  } = useRowHeightsCache()

  const orderManagerData = useOrderManager({
    defaultField: defaultOrderField,
    orderFieldConfig
  })

  return (
    <FilterManager
      defaultQuickFilterId={initialQuickFilterID}
      filterType={filterType}
    >
      {(filterManagerChildProps) => {
        return children({
          ...orderManagerData,
          ...filterManagerChildProps,
          maxCellHeightsByRow,
          updateCellHeight,
          registerListRef,
          recomputeRowHeights,
          hasData,
          onHasData
        })
      }}
    </FilterManager>
  )
}
